import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { DTB } from 'views/App/Portal/DTB/_types/dtb';

export default function useDTB(
  orgId: string,
  dtbId: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs/${dtbId}`;

  return useQuery<DTB, ServerErrorResponse>(
    ['dtb', orgId, dtbId],
    async ({ signal }): Promise<DTB> => {
      try {
        const response = await fetcher({
          method: 'GET',
          url,
          options: { signal },
        });
        return response;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      enabled: !!orgId && !!dtbId,
      ...options,
      keepPreviousData: true,
    }
  );
}
